import React from "react";
import { Button, Col, Row } from "antd";
import { TInput } from "../../../form/Field/TInput";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useFieldArray } from "react-hook-form";
import styled from "styled-components";
import { StyledMinimalButton } from "./finishingCheckbox";

const BindingSecondOption = (props) => {
  const { secondOptionIndex, control, errors, watch } = props;
  const { fields, remove, append } = useFieldArray({
    control,
    name: `second_option[${secondOptionIndex}].value`,
  });

  React.useEffect(() => {
    if (fields.length < 1) {
      append({ value: null });
    }
  }, []);

  return (
    <StyledAppend>
      {fields.map((item, index) => {
        return (
          <Row key={item.id} gutter={6}>
            <Col xs={22}>
              <TInput
                errors={errors}
                name={`second_option[${secondOptionIndex}].value[${index}].value`}
                placeholder="Value"
                defaultValue={item.value}
                propsInput={{
                  control: control,
                }}
              />
            </Col>
            <Col xs={2}>
              <Button
                type="dashed"
                danger
                icon={<DeleteOutlined />}
                size="medium"
                onClick={() => remove(index)}
                disabled={index === 0}
              />
            </Col>
          </Row>
        );
      })}
      <StyledMinimalButton
        type="link"
        style={{ padding: 0 }}
        icon={<PlusOutlined />}
        onClick={() => {
          append({ value: "" });
        }}
      >
        Add Value
      </StyledMinimalButton>
    </StyledAppend>
  );
};

const StyledAppend = styled.div`
  padding: ${(props) => props.theme.spacing[3]};
  background-color: ${(props) => props.theme.colors.grey[100]};
  border: 1px solid ${(props) => props.theme.colors.grey[400]};
`;

export default BindingSecondOption;
